<div>
  <h1>
    Impressum und Offenlegung gemäß §§ 24 und 25 MedienG
  </h1>
  <p>
    Verein Österreichisches Sprachdiplom Deutsch, Kurzform: Verein ÖSD
  </p>

  <h3>
    Medieninhaber und Herausgeber
  </h3>
  <p>
    Verein Österreichisches Sprachdiplom Deutsch (ÖSD)<br>
    Hörlgasse 12<br>
    1090 Wien<br>
    Österreich<br>
    Tel: <span id="tel"></span><br>
    E-Mail: <span id="email"></span><br>
    ZVR-Zahl: 699451984<br>
  </p>

  <hr class="smallhr">

  <h3>
    Vertretung nach außen:
  </h3>
  <p>
    Geschäftsführung: Dr.<sup>in</sup> Manuela Glaboniat<br>
    Stellvertretung: Chris C. J. Punter<br>
    Vorsitzender des ÖSD-Kuratoriums: Mag. Thomas Fritz, PhD<br>
  </p>

  <hr class="smallhr">

  <h3>
    Vereinszweck bzw. Unternehmensgegenstand
  </h3>
  <p>
    Das ÖSD ist ein Verein mit eigener Rechtspersönlichkeit, dessen Tätigkeit nicht auf Gewinn gerichtet ist und der
    ausschließlich gemeinnützige Zwecke im Sinne der §§ 34 bis 47 BAO verfolgt.
    Der Vereinszweck umfasst vor allem:<br><br>

    a. die Überprüfung und Zertifizierung von Sprachkenntnissen und -kompetenzen in Deutsch<br>
    b. die Bekannt- und Bewusstmachung des Deutschen als plurizentrische Sprache<br>
    c. die Unterstützung der sprachpolitischen Ziele Österreichs<br>
    d. die Information über Entwicklungen der deutschen Sprache nach sprachpolitischen Erfordernissen<br>
    e. die Teilnahme an nationaler und internationaler Forschung der Sprachwissenschaft, insbesondere zu den
    einschlägigen Fachbereichen „Testen, Prüfen, Leistungsmessung und Zertifizieren im Bereich Deutsch als Fremdsprache
    (DaF), Zweitsprache (DaZ) oder Erstsprache (DaM)“

    Alle Medien des Vereins ÖSD dienen der Information über Themen, Projekte und Angebote des ÖSD und der Verbreitung
    von wesentlichen Informationen in Bezug auf die oben genannten Vereinszwecke.
  </p>

  <hr class="smallhr">

  <h3>
    Haftungsausschluss
  </h3>
  <p>

    Die Inhalte dieses Mediums wurden mit größtmöglicher Sorgfalt recherchiert und erstellt. Für die Richtigkeit,
    Vollständigkeit und Aktualität der Inhalte wird keine Haftung übernommen. Weder der Verein ÖSD noch andere, an der
    Erstellung dieses Mediums Beteiligte haften für Schäden jedweder Art, die durch die Nutzung, Anwendung und
    Weitergabe der dargebotenen Inhalte entstehen. Sofern dieses Medium Verweise auf andere Medien Dritter enthält, auf
    die der Verein ÖSD keinen Einfluss ausübt, ist eine Haftung für die Inhalte dieser Medien ausgeschlossen. Für die
    Richtigkeit der Informationen in Medien Dritter ist der jeweilige Medieninhaber verantwortlich.
  </p>

  <hr class="smallhr">

  <h3>
    Urheberrecht
  </h3>

  <p>
    Alle in diesem Medium veröffentlichten Inhalte und Ideen sind urheberrechtlich geschützt und dienen zu Ihrer
    Information. Ohne vorherige schriftliche Zustimmung des Urhebers ist jede technisch mögliche oder erst in Hinkunft
    möglich werdende Art der Vervielfältigung, Bearbeitung, Verbreitung und Verwertung untersagt, sei es entgeltlich
    oder unentgeltlich.
  </p>

  <hr class="smallhr">

  <h3>
    Datenschutz
  </h3>

  <p>
    Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Sollten dennoch
    personenbezogene Daten erhoben werden, werden diese ohne Ihre ausdrückliche Zustimmung nicht an Dritte
    weitergegeben. Der Nutzung der im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von
    nicht ausdrücklich angeforderter Werbung oder Informationsmaterialien wird hiermit ausdrücklich widersprochen.
    Weiteres entnehmen Sie bitte unserer Datenschutzerklärung.
  </p>

  <hr class="smallhr">

  <h3>
    Webauftritt / Design und Programmierung
  </h3>

  <p>
    Bastian Ferch<br>
    Maximilian Haller<br>
    Maximilian Riedel
  </p>
</div>
